import { createRouter, createWebHistory } from 'vue-router';
import type { RouteRecordRaw } from 'vue-router';
import appRoutes from './routes';
import { executeGuards } from './guards';
import { handleChunkLoadError } from './utils/chunkErrorHandler';

const routes: Array<RouteRecordRaw> = [...appRoutes];

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
});

router.beforeEach(async (to, from) => {
  return await executeGuards(to, from);
});

router.onError(handleChunkLoadError);

export default router;
